export type CsvCellValue = string | number | boolean | null | undefined;

export interface BuildCsvOptions {
  separator?: string;
  lineBreak?: '\n' | '\r\n';
  prependBom?: boolean;
}

export interface DownloadCsvOptions extends BuildCsvOptions {
  mimeType?: string;
  /** Document to start the download from; defaults to the global one. */
  document?: Document;
}

export function escapeCsvCell(value: CsvCellValue, separator = ','): string {
  const stringValue = value == null ? '' : String(value);

  if (
    !stringValue.includes('"') &&
    !stringValue.includes('\n') &&
    !stringValue.includes('\r') &&
    !stringValue.includes(separator)
  ) {
    return stringValue;
  }

  return `"${stringValue.replace(/"/g, '""')}"`;
}

export function buildCsv(
  rows: CsvCellValue[][],
  options: BuildCsvOptions = {}
): string {
  const separator = options.separator ?? ',';
  const lineBreak = options.lineBreak ?? '\n';

  const content = rows
    .map(row => row.map(cell => escapeCsvCell(cell, separator)).join(separator))
    .join(lineBreak);

  return options.prependBom ? `\uFEFF${content}` : content;
}

export function downloadCsv(
  rows: CsvCellValue[][],
  fileName: string,
  options: DownloadCsvOptions = {}
): void {
  const csv = buildCsv(rows, options);
  const mimeType = options.mimeType ?? 'text/csv;charset=utf-8;';

  const blob = new Blob([csv], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = (options.document ?? document).createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}
